export const admin_TranslationLabel = "admin_role"
export const endUser_TranslationLabel = "end_user_role"

export const lookUptype_POD_Status = "POD Status"
export const lookUptype_Shipment_Delivery_Status = "Shipment Delivery Status"

export const POD_Open_TranslationLabel = "pod_open"
export const POD_Delivered_TranslationLabel = "pod_delivered"
export const POD_Reviewed_TranslationLabel = "pod_reviewed"

export const POD_Open_Lookupname = "pod_open"//"Open"
export const POD_Delivered_Lookupname = "pod_delivered"//"Delivered"
export const POD_Reviewed_Lookupname = "pod_reviewed"//"Revisado"

export const shipment_delivery_open_Lookupname = "shipment_delivery_open"//"Open"
export const shipment_delivery_pick_Lookupname = "shipment_delivery_pick"//"Picked"
export const shipment_delivery_shipping_Lookupname = "shipment_delivery_shipping"//"Shipped"
export const shipment_delivery_delivered_Lookupname = "shipment_delivery_delivered"//"Delivered"

export const pagekey_shipmentlist = "shipmentList"
export const pagekey_userlist = "userList"
export const pagekey_customerprofilelist = "customerProfileList"
export const pagekey_viewcustomshiptoparty = "viewcustomshiptoparty"

export const pod_status = "podStatus"
export const shipment_status = "deliveryStatus"
export const active_status = "isActive"




